import { useCallback, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { fetchDataByIds } from "services/resultEntryReportMaster";

const useRefetchByIds = (queryKey) => {
  const queryClient = useQueryClient();

  const isRefetchingByIds = useRef(false);

  const refetchByIds = useCallback(
    async (ids = []) => {
      if (!ids.length) return;

      isRefetchingByIds.current = true;

      try {
        await queryClient.cancelQueries(queryKey);

        const res = await fetchDataByIds(ids);
        const newData = res?.data?.data;
        if (!newData?.length) return;

        queryClient.setQueryData(queryKey, (oldData) => {
          if (!oldData?.data?.data) return oldData;

          const updatedRows = oldData.data.data.map((row) => {
            const matched = newData.find(
              (newRow) =>
                newRow.appointment_id === row.appointment_id &&
                newRow.investigation_data?.investigation_id ===
                  row.investigation_data?.investigation_id,
            );
            return matched ? { ...row, ...matched, _index: row._index } : row;
          });

          return {
            ...oldData,
            data: {
              ...oldData.data,
              data: updatedRows,
            },
          };
        });
      } finally {
        setTimeout(() => {
          isRefetchingByIds.current = false;
        }, 500);
      }
    },
    [queryClient, queryKey],
  );

  return { refetchByIds, isRefetchingByIds };
};

export default useRefetchByIds;
